import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import McpServerApi from '@/common/constant/api/McpServerApi';
import { v4 as uuidv4 } from 'uuid';
import { getMCPServer, updateMCPServer } from '@/service/mcpServerService';
import {
    openaiConnectorList,
} from './MCPServerUIHandler';

const createNewInitApiData = () => {
    const { OAUTH2, JWT, APIKEY, BEARER } = Constant.AUTH_METHOD_MCP_SERVER;
    return {
        // Invisible
        id: `createNew_${uuidv4()}`, // ID
        affiliationOrganization: localStorageUtil.getAffiliationOrganization(),
        affiliationProject: localStorageUtil.getSelectedProjectId(), // String # String / NA
        connectId: '', // String! # Base62 String
       
        type: Constant.MCP_SERVER_TYPE.MCP_SERVER,
        serverName: '', // String
       
        openaiConnectorId: 'connector_googlecalendar',
        serverURL: '', // String
        authMethod: 'apiKeySetting', // String # OAUTH2 / JWT / NONE
        
        oauth2Setting: transformMethodSetting(OAUTH2, {}),
        jwtSetting: transformMethodSetting(JWT, {}),
        apiKeySetting: transformMethodSetting(APIKEY, {}),
        bearerSetting: transformMethodSetting(BEARER, {}),

        status: Constant.MCP_SERVER_CONNECT_STATUS.NOT_CONNECT, // String
        isActiveCorp: '',
        projectActived: [],
        memo: '', // String 

        // Invisible
        creator: localStorageUtil.getUserDetailId(), // ID
        createdAt: '', // AWSDateTime
        updator: localStorageUtil.getUserDetailId(), // ID
        updatedAt: '', // AWSDateTime
        deletedAt: '', // AWSDateTime
        lastTestedAt: '' // AWSDateTime
    };
};

const transformApiDataClient = backendData => {
    const { OAUTH2, JWT, APIKEY, BEARER } = Constant.AUTH_METHOD_MCP_SERVER;
    let transformed = {
        // Invisible
        id: backendData.id, // ID
        affiliationOrganization: backendData.affiliationOrganization, // String!
        affiliationProject: backendData.affiliationProject, // String # String / NA
        type: backendData.type,
        openaiConnectorId: backendData.openaiConnectorId, 
        connectId: backendData.connectId, // String! # Base62 String

        // Visible
        serverName: backendData.serverName, // String
        serverURL: backendData.serverURL, // String

        authMethod: transformAuthMethod(backendData.authMethod), // String # OAUTH2 / JWT / NONE / APIKEY / BEARER
        oauth2Setting: transformMethodSetting(OAUTH2, backendData.oauth2Setting, backendData.openaiConnectorId),
        jwtSetting: transformMethodSetting(JWT, backendData.jwtSetting),
        apiKeySetting: transformMethodSetting(APIKEY, backendData.apiKeySetting),
        bearerSetting: transformMethodSetting(BEARER, backendData.bearerSetting),

        status: backendData.status, // String # SUCCESS / WARNING / FAIL
        isActiveCorp: backendData.isActiveCorp,
        memo: backendData.memo,
        projectActived: backendData.projectActived,

        // Invisible
        creator: backendData?.creator, // isCreateNew ? localStorageUtil.getUserDetailId() : uuidv4(), // ID
        createdAt: backendData?.createdAt, // isCreateNew ? '' : getCurrentTime(), // AWSDateTime
        updator: backendData?.updator, // isCreateNew ? localStorageUtil.getUserDetailId() : uuidv4(), // ID
        updatedAt: backendData?.updatedAt, // isCreateNew ? '' : getCurrentTime(), // AWSDateTime
        deletedAt: backendData?.deletedAt, // isCreateNew ? '' : getCurrentTime(), // AWSDateTime
        lastTestedAt: backendData?.lastTestedAt // isCreateNew ? '' : getCurrentTime() // AWSDateTime
    };


    return transformed;
};

const transformAuthMethod = authMethod => {
    const { OAUTH2, JWT, NONE, APIKEY, BEARER } = Constant.AUTH_METHOD_MCP_SERVER;
    const BACKEND_VALUES = [OAUTH2, JWT, NONE, APIKEY, BEARER];
    const FRONTEND_VALUES = ['oauth2Setting', 'jwtSetting', 'none', 'apiKeySetting', 'bearerSetting'];

    // Backend → Frontend
    if (BACKEND_VALUES.includes(authMethod)) {
        const index = BACKEND_VALUES.indexOf(authMethod);
        return FRONTEND_VALUES[index];
    }

    // Frontend → Backend
    if (FRONTEND_VALUES.includes(authMethod)) {
        const index = FRONTEND_VALUES.indexOf(authMethod);
        return BACKEND_VALUES[index];
    }

    throw new Error('authMethod is invalid value');
};
// comment for now
// const transformMethodSetting = (authMethod, data = {}) => {
//     const isCreateNew = Utils.isEmptyObject(data);
//
//     let scopeValue = '';
//     if (!isCreateNew && !Utils.isEmptyString(data.scope)) {
//         scopeValue = data.scope;
//     }
//
//     let apiKeyValueString = '';
//     if (!isCreateNew && !Utils.isEmptyArray(data.apiKeyValue)) {
//         apiKeyValueString = data.apiKeyValue
//             .map(json => {
//                 const obj = Utils.convertJSONDataToObject(json);
//
//                 if (Utils.isEmptyObject(obj)) {
//                     return '';
//                 }
//                 const [key, value] = Object.entries(obj)[0];
//                 return `${key} = ${value}`;
//             })
//             .filter(string => Boolean(string))
//             .join('\n');
//     }
//
//     let metaDataString = '';
//     if (!isCreateNew && !Utils.isEmptyObject(data.apiKeyValue)) {
//         metaDataString = JSON.stringify(data.apiKeyValue);
//     }
//
//     // type Oauth2Setting
//     const Oauth2Setting = {
//         clientId: isCreateNew ? '' : data.clientId,
//         secret: isCreateNew ? '' : data.secret,
//         authUrl: isCreateNew ? '' : data.authUrl,
//         tokenUrl: isCreateNew ? '' : data.tokenUrl,
//         scope: isCreateNew ? '' : scopeValue,
//         accessToken: isCreateNew ? '' : data.accessToken,
//         refreshToken: isCreateNew ? '' : data.refreshToken
//     };
//
//     // type JwtSetting
//     const JwtSetting = {
//         iss: isCreateNew ? '' : data.iss,
//         sub: isCreateNew ? '' : data.sub,
//         aud: isCreateNew ? '' : data.aud,
//         privateKey: isCreateNew ? '' : data.privateKey,
//         scope: isCreateNew ? '' : scopeValue,
//         exp: isCreateNew ? '' : data.exp,
//         accessToken: isCreateNew ? '' : data.accessToken
//     };
//
//     // type BaseSetting
//     const BaseSetting = {
//         userName: isCreateNew ? '' : data.userName,
//         password: isCreateNew ? '' : data.password,
//         apiKeyValue: isCreateNew ? '' : apiKeyValueString,
//         metaData: isCreateNew ? '' : metaDataString
//     };
//
//     let setting = {};
//     const { OAUTH2, JWT, BASE } = Constant.AUTH_METHOD_MCP_SERVER;
//     switch (authMethod) {
//         case OAUTH2:
//             setting = Oauth2Setting;
//             break;
//         case JWT:
//             setting = JwtSetting;
//             break;
//         case BASE:
//             setting = BaseSetting;
//             break;
//         default:
//             break;
//     }
//     return setting;
// };

const transfromScopeValue = (scope, openaiConnectorId) => {
    if (!scope) return [];
    const arr = scope.split(",");
    const newScope = [];
    openaiConnectorList.forEach(connector => {
        if (connector.value === openaiConnectorId) {
            const scopes = connector.scopes || [];
            scopes.forEach(s => {
                if (arr.includes(s.value)) {
                    newScope.push(s);
                }
            });
        }
    });
    return newScope;

}

const transformMethodSetting = (authMethod, data = {}, openaiConnectorId = Constant.DEFAULT_CONNECTOR_VALUE.OPENAI_CONNECTOR_ID) => {
    const isCreateNew = Utils.isEmptyObject(data);

    const getScopeValue = () =>
        !isCreateNew && !Utils.isEmptyString(data.scope) ? data.scope : '';

    let scopeValue = isCreateNew ? Constant.DEFAULT_CONNECTOR_VALUE.SCOPE : data.scope;
    const buildOauth2Setting = () => ({
        redirectUrl: isCreateNew ? '' : data.redirectUrl,
        clientId: isCreateNew ? '' : data.clientId,
        secret: isCreateNew ? '' : data.secret,
        authUrl: isCreateNew ? '' : data.authUrl,
        tokenUrl: isCreateNew ? '' : data.tokenUrl,
        scope: transfromScopeValue(scopeValue, openaiConnectorId),
        accessToken: isCreateNew ? '' : data.accessToken,
        refreshToken: isCreateNew ? '' : data.refreshToken
    });

    const buildJwtSetting = () => ({
        iss: isCreateNew ? '' : data.iss,
        sub: isCreateNew ? '' : data.sub,
        aud: isCreateNew ? '' : data.aud,
        privateKey: isCreateNew ? '' : data.privateKey,
        scope: isCreateNew ? '' : getScopeValue(),
        exp: isCreateNew ? '' : data.exp,
        accessToken: isCreateNew ? '' : data.accessToken
    });

    const buildApiKeySetting = () => ({
        apiKey: isCreateNew ? '' : data.apiKey,
    });

    const buildBearerSetting = () => ({
        bearer: isCreateNew ? '' : data.bearer,
    });

    const { OAUTH2, JWT, APIKEY, BEARER } = Constant.AUTH_METHOD_MCP_SERVER;

    switch (authMethod) {
        case OAUTH2:
            return buildOauth2Setting();
        case JWT:
            return buildJwtSetting();
        case APIKEY:
            return buildApiKeySetting();
        case BEARER:
            return buildBearerSetting();
        default:
            return {};
    }
};

const transformJSONObj = (obj) => {
    if (!obj) return '';

    if (Utils.isObjectType(obj)) {
        if (Utils.isNotEmptyObj(obj)) {
            return JSON.stringify(obj, null, 4);
        } else {
            return '';
        }
    }

    return obj;
};

const convertJSONObjBackend = (data) => {
    if (data === undefined || data === null || data === '') return JSON.stringify({});

    try {
        if (typeof data === 'string') {
            // Kiểm tra nếu là string, phải là JSON hợp lệ
            const parsed = JSON.parse(data);
            if (Utils.isObjectType(parsed)) {
                return data; // string JSON object hợp lệ
            } else {
                return JSON.stringify({}); // string JSON nhưng không phải object (VD: array, string primitive)
            }
        }

        if (Utils.isObjectType(data)) {
            return JSON.stringify(data); // object literal → stringify
        }

        return JSON.stringify({}); // không phải object hợp lệ
    } catch {
        return JSON.stringify({}); // parse lỗi
    }
};

const convertScopeValueBackend = inputStr => {
    if (typeof inputStr !== 'string') return [];
    return inputStr.trim().split(/\s+/); // splitBySpace
}

const convertApiKeyValueBackend = inputStr => {
    if (!inputStr) return [];

    return inputStr
        .split('\n') // tách từng dòng
        .map(line => line.trim()) // loại bỏ khoảng trắng đầu cuối
        .filter(line => line !== '') // bỏ dòng trống
        .map(line => {
            const [key, ...rest] = line.split('=');
            return {
                key: key.trim(),
                value: rest.join('=').trim() // xử lý trường hợp value chứa dấu =
            };
        });
};

const getOwnerByPanelType = (panelType = Constant.PANEL_TYPE.SYSTEM_MANAGEMENT) => {
    return Constant.PANEL_TYPE.SYSTEM_MANAGEMENT === panelType
        ? Constant.MCP_SERVER_OWNER_BY.ORG
        : Constant.MCP_SERVER_OWNER_BY.PROJECT;
};

const handleDeleteMCPServerData = async (corporationInuse, projectInuse, userId, deleteData) => {
    try {
        const requestDto = {
            handleMethod: McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.DELETE_BY_ID,
            corporationInuse: corporationInuse || localStorageUtil.getAffiliationOrganization(),
            projectInuse: projectInuse || localStorageUtil.getSelectedProjectId(),
            userId: userId || localStorageUtil.getUserDetailId(),
            deleteData: {
                id: deleteData.id
            }
        };
        const response = await updateMCPServer(requestDto);
        return response;
    } catch (err) {
        console.log('deletedMCPServerData err:', err);
    }
};

const handleUpdateMCPServerData = async (corporationInuse, projectInuse, userId, updateData) => {
    try {
        const requestDto = {
            handleMethod: McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.UPDATE_BY_ID,
            corporationInuse: corporationInuse || localStorageUtil.getAffiliationOrganization(),
            projectInuse: projectInuse || localStorageUtil.getSelectedProjectId(),
            userId: userId || localStorageUtil.getUserDetailId(),
            updateData: {
                id: updateData.id,
                connectId: updateData.connectId || '',
                serverName: updateData.serverName,
                serverURL: updateData.serverURL,
                authMethod: transformAuthMethod(updateData.authMethod),
                type: updateData.type,
                openaiConnectorId: updateData.openaiConnectorId,
                oauth2Setting: {
                    clientId: updateData.oauth2Setting.clientId || '',
                    secret: updateData.oauth2Setting.secret || '',
                    scope: formatScopeValue(updateData.oauth2Setting.scope) || '',

                    authUrl: updateData.oauth2Setting.authUrl || '',
                    tokenUrl: updateData.oauth2Setting.tokenUrl || '',
                    redirectUrl: updateData.oauth2Setting.redirectUrl || '',

                },
                jwtSetting: {
                    iss: updateData.jwtSetting.iss || '',
                    sub: updateData.jwtSetting.sub || '',
                    aud: updateData.jwtSetting.aud || '',
                    scope: updateData.jwtSetting.scope || '',
                    privateKey: updateData.jwtSetting.privateKey || ''
                },
                apiKeySetting: {
                    apiKey: updateData.apiKeySetting.apiKey || '',
                    // metaData: updateData.apiKeySetting.metaData || ''
                },
                bearerSetting: {
                    bearer: updateData.bearerSetting.bearer || '',
                    // metaData: updateData.bearerSetting.metaData || ''
                },
                status: updateData.status,
                isActiveCorp: updateData.isActiveCorp || '',
                memo: updateData.memo,
                projectActived: updateData.projectActived || [],
                updator: userId
            }
        };

        const response = await updateMCPServer(requestDto);
        return response;
    } catch (err) {
        console.log('updateMCPServerData err:', err);
    }
};

const formatScopeValue = (scope) => {
    if (scope && Array.isArray(scope)) {
        let newScope = scope.map(item => item.value);
        return newScope.join(',');
    }
    return ''
}

const handleCreateMCPServer = async (
    corporationInuse,
    projectInuse,
    userId,
    createNewData
) => {
    try {
        const requestDto = {
            handleMethod: McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.CREATE_NEW,
            corporationInuse: corporationInuse || localStorageUtil.getAffiliationOrganization(),
            projectInuse: projectInuse || localStorageUtil.getSelectedProjectId(),
            userId: userId || localStorageUtil.getUserDetailId(),
            createNewData: {
                connectId: createNewData.connectId || '',
                serverName: createNewData.serverName,
                serverURL: createNewData.serverURL,
                authMethod: transformAuthMethod(createNewData.authMethod),
                type: createNewData.type,
                openaiConnectorId: createNewData.openaiConnectorId,
                oauth2Setting: {
                    clientId: createNewData.oauth2Setting.clientId || '',
                    secret: createNewData.oauth2Setting.secret || '',
                    scope: formatScopeValue(createNewData.oauth2Setting.scope) || '',
                    authUrl: createNewData.oauth2Setting.authUrl || '',
                    tokenUrl: createNewData.oauth2Setting.tokenUrl || '',
                    redirectUrl: createNewData.oauth2Setting.redirectUrl || '',
                },
                jwtSetting: {
                    iss: createNewData.jwtSetting.iss || '',
                    sub: createNewData.jwtSetting.sub || '',
                    aud: createNewData.jwtSetting.aud || '',
                    scope: createNewData.jwtSetting.scope || '',
                    privateKey: createNewData.jwtSetting.privateKey || ''
                },
                apiKeySetting: {
                    apiKey: createNewData.apiKeySetting.apiKey || '',
                    // metaData: createNewData.apiKeySetting.metaData || ''
                },
                bearerSetting: {
                    bearer: createNewData.bearerSetting.bearer || '',
                    // metaData: createNewData.bearerSetting.metaData || ''
                },
                status: createNewData.status,
                isActiveCorp: createNewData.isActiveCorp || '',
                memo: createNewData.memo,
                projectActived: createNewData.projectActived || [],
                creator: userId
            }
        };
    
        const response = await updateMCPServer(requestDto);
        return response;
    } catch (err) {
        
        console.log('createMCPServer err:', err);
        return null;
    }
};

const handleUpdateMCPServerByAction = async (actionType, payload, args) => {
    const { corporationInuse, projectInuse, userId, panelType } = args;
    let handled;
    switch (actionType) {
        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.CREATE_NEW:
            handled = await handleCreateMCPServer(
                corporationInuse,
                projectInuse,
                userId,
                payload
            );
            break;
        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.UPDATE_BY_ID:
            handled = await handleUpdateMCPServerData(
                corporationInuse,
                projectInuse,
                userId,
                payload
            );
            break;

        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.TOGGLE_ACTIVE_IN_ORG:
            const requestDto = {
                handleMethod: McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.TOGGLE_ACTIVE_IN_ORG,
                corporationInuse: corporationInuse || localStorageUtil.getAffiliationOrganization(),
                projectInuse: projectInuse || localStorageUtil.getSelectedProjectId(),
                userId: userId || localStorageUtil.getUserDetailId(),
                updateData: {
                    ...payload,
                    id: payload.id,
                    updator: userId
                }
            };
            handled = await updateMCPServer(requestDto);
            // handled = await handleUpdateMCPServerData(
            //     corporationInuse,
            //     projectInuse,
            //     userId,
            //     payload
            // );
            break;
        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.DELETE_BY_ID:
            handled = await handleDeleteMCPServerData(
                corporationInuse,
                projectInuse,
                userId,
                payload
            );
            break;
        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_TEST:
            handled = await handleTestMCPServerData(
                corporationInuse,
                projectInuse,
                userId,
                payload
            );
            break;
        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_AUTH:
            handled = await callCheckAuthenMCPServer(
                corporationInuse,
                projectInuse,
                userId,
                payload,
                panelType
            );
            break;
        default:
            break;
    }
    return handled;
};

const getListMCPServer = async (
    panelType,
    corporationInuse,
    projectInuse,
    userId,
    getMethod = McpServerApi.MCP_SERVER_GET_METHOD.GET_LIST_PAGINATION,
    queryParams = {}
) => {
    try {
        let params = {
            corporationInuse: corporationInuse || localStorageUtil.getAffiliationOrganization(),
            projectInuse: projectInuse || localStorageUtil.getSelectedProjectId(),
            userId: userId || localStorageUtil.getUserDetailId(),
            getMethod: getMethod,
            queryParams: JSON.stringify({
                limit: queryParams.limit || Constant.MCP_SERVER_GET_LIST_LIMIT,
                lastEvaluatedKey: queryParams?.lastEvaluatedKey
            })
        };

        const response = await getMCPServer(params);
        if (!response.success) {
            return {
                listMCPServer: [],
                error: response?.error || Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR
            };
        }

        const payload = Utils.convertJSONDataToObject(response.payload);
        const listMCPServer = payload?.listItem || [];
        return { listMCPServer, error: '' };
    } catch (error) {
        console.log('getListMCPServer error: ', error);
    }
    return [];
};

const callCheckAuthenMCPServer = async (corporationInuse, projectInuse, userId, dataAuth, panelType) => {
    let MCPServerData = dataAuth;
    if (!dataAuth.id.includes(Constant.PREFIX_MCP_SERVER)) {
        MCPServerData = await handleCreateMCPServer(
            corporationInuse,
            projectInuse,
            userId,
            dataAuth
        );
    }
    let authMethod = MCPServerData.authMethod;
    let resultAuthen = '';

    switch (authMethod) {
        // case Constant.AUTH_METHOD_MCP_SERVER.OAUTH2:
        case 'oauth2Setting':
            return handlerAuthenByOAuth2(MCPServerData, corporationInuse, projectInuse, userId);
        // case Constant.AUTH_METHOD_MCP_SERVER.JWT:
        case 'jwtSetting':
            resultAuthen = await handlerAuthenByJwt(MCPServerData, corporationInuse, projectInuse, userId);
            break;
        // case Constant.AUTH_METHOD_MCP_SERVER.BASE:
        case 'baseSetting':
            resultAuthen = await handlerAuthenByBase(MCPServerData, corporationInuse, projectInuse, userId);
            break;
        default:
            break;
    }
    return resultAuthen;
};

const handlerAuthenByOAuth2 = (
    dataAuth,
    corporationInuse,
    projectInuse,
    userId
) => {
    // comment for now
    // Call create record => connectId
    // let connectId = 'connectId';

    // redirect authen
    let oauth2Setting = dataAuth.oauth2Setting;
    let authUrl = oauth2Setting.authUrl;
    let clientId = oauth2Setting.clientId;
    let redirectUri = `${process.env.REACT_APP_DOMAIN_NAME}/oauth2callback`;
    // let redirectUri = `http://localhost:3000/oauth2callback`
    let scope = oauth2Setting.scope;

    const stateObject = createRequestDtoForMethod(
            dataAuth,
            corporationInuse,
            projectInuse,
            userId,
            McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_AUTH
        )

    const state = btoa(JSON.stringify(stateObject));

    const authUrlByOAuth2 = `${authUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${encodeURIComponent(
        scope
    )}&access_type=offline&prompt=consent&state=${encodeURIComponent(state)}`;

    window.location.href = authUrlByOAuth2;
};

const handlerAuthenByJwt = async (dataAuth, corporationInuse, projectInuse, userId) => {
    try {
        const requestDto = createRequestDtoForMethod(
            dataAuth,
            corporationInuse,
            projectInuse,
            userId,
            McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_AUTH
        )

        const resultData = await updateMCPServer(requestDto);
        let result = Utils.convertJSONDataToObject(resultData.payload);
        let dataUpdate = {...dataAuth};

        if (result.status === Constant.MCP_SERVER_CONNECT_STATUS.SUCCESS) {
            dataUpdate.status = result.status;
        } else {
            dataUpdate.status = Constant.MCP_SERVER_CONNECT_STATUS.FAIL;
        }
        dataUpdate.jwtSetting = result.jwtSetting;
        return dataUpdate;
    } catch (err) {
        console.log('ERROR _ handlerAuthenByJwt err:', err);
        return err
    }
};

const handlerAuthenByBase = async (dataAuth, corporationInuse, projectInuse, userId) => {
    try {
        const requestDto = createRequestDtoForMethod(
            dataAuth,
            corporationInuse,
            projectInuse,
            userId,
            McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_AUTH
        )

        const resultData = await updateMCPServer(requestDto);
        let result = Utils.convertJSONDataToObject(resultData.payload);
        let dataUpdate = { ...dataAuth };
        let baseSetting = { ...dataAuth.baseSetting };

        if (result.status === Constant.MCP_SERVER_CONNECT_STATUS.SUCCESS) {
            dataUpdate.status = result.status;
            baseSetting.metaData = result.data;
        } else {
            dataUpdate.status = Constant.MCP_SERVER_CONNECT_STATUS.FAIL;
            baseSetting.metaData = result.error;
        }
        return dataUpdate;
    } catch (err) {
        console.log('ERROR _ handlerAuthenByBase err:', err);
        return err
    }
};

const handleTestMCPServerData = async (corporationInuse, projectInuse, userId, dataTest) => {
    try {
        const requestDto = createRequestDtoForMethod(
            dataTest,
            corporationInuse,
            projectInuse,
            userId,
            McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_TEST
        )

        const resultData = await updateMCPServer(requestDto);
        return resultData;
    } catch (err) {
        console.log('ERROR _ handleTestMCPServerData err:', err);
        return err
    }
};

const createRequestDtoForMethod = (
    dataDto,
    corporationInuse,
    projectInuse,
    userId,
    method = McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_TEST
) => {
    let dataCommon = {
        id: dataDto.id,
        connectId: dataDto.connectId,
        serverName: dataDto.serverName,
        serverURL: dataDto.serverURL,
        authMethod: transformAuthMethod(dataDto.authMethod),
        type: dataDto.type,
        openaiConnectorId: dataDto.openaiConnectorId,
        oauth2Setting: {
            clientId: dataDto.oauth2Setting.clientId || '',
            secret: dataDto.oauth2Setting.secret || '',
            scope: formatScopeValue(dataDto.oauth2Setting.scope) || '',

            authUrl: dataDto.oauth2Setting.authUrl || '',
            tokenUrl: dataDto.oauth2Setting.tokenUrl || '',
            accessToken: dataDto.oauth2Setting.accessToken || '',
            refreshToken: dataDto.oauth2Setting.refreshToken || '',
            gasProjectId: dataDto.oauth2Setting.gasProjectId || '',
            redirectUrl: dataDto.oauth2Setting.redirectUrl || '',
        },
        jwtSetting: {
            iss: dataDto.jwtSetting.iss || '',
            sub: dataDto.jwtSetting.sub || '',
            aud: dataDto.jwtSetting.aud || '',
            scope:dataDto.jwtSetting.scope || '',
            privateKey: dataDto.jwtSetting.privateKey || '',
            exp: dataDto.jwtSetting.exp || '',
            accessToken: dataDto.jwtSetting.accessToken
        },
        apiKeySetting: {
            apiKey: dataDto.apiKeySetting.apiKey || '',
            // metaData: dataDto.apiKeySetting.metaData || ''
        },
        bearerSetting: {
            bearer: dataDto.bearerSetting.bearer || '',
            // metaData: dataDto.bearerSetting.metaData || ''
        },
        status: dataDto.status,

        isActiveCorp: dataDto.isActiveCorp || '',
        memo: dataDto.memo,
        projectActived: dataDto.projectActived || [],
        
        updator: userId,
        // creator: userId
    };
    let requestDtoCommon = {
        handleMethod: method,
        corporationInuse,
        projectInuse,
        userId
    };
    let requestDto = { ...requestDtoCommon };
    switch (method) {
        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_TEST:
        case McpServerApi.MCP_SERVER_UPDATE_ACTION_TYPE.RUN_AUTH:
            requestDto = {
                ...requestDto,
                updateData: dataCommon
            };
            break;
        default:
            break;
    }

    return requestDto;
};

const createTestList = () => {
    const { OAUTH2, JWT, BEARER, APIKEY } = Constant.AUTH_METHOD_MCP_SERVER;
    let testList = []
    let item = {
        // Invisible
        id: `mcpServer_${uuidv4()}`, // ID
        affiliationOrganization: localStorageUtil.getAffiliationOrganization(),
        affiliationProject: localStorageUtil.getSelectedProjectId(), // String # String / NA
        connectId: '', // String! # Base62 String

        // Visible
        serverName: 'New MCP Server', // String
        serverURL: '', // String

        authMethod: 'APIKEY', // String # OAUTH2 / JWT / BASE / NONE / APIKEY / BEARER
        oauth2Setting: transformMethodSetting(OAUTH2, {}),
        jwtSetting: transformMethodSetting(JWT, {}),
        bearerSetting: transformMethodSetting(BEARER, {}),
        apiKeySetting: transformMethodSetting(APIKEY, {}),
        status: Constant.MCP_SERVER_CONNECT_STATUS.NOT_CONNECT, // String

        isActiveCorp: true,
        memo: '',
        projectActived: [],

        // Invisible
        creator: localStorageUtil.getUserDetailId(), // ID
        createdAt: '', // AWSDateTime
        updator: localStorageUtil.getUserDetailId(), // ID
        updatedAt: '', // AWSDateTime
        deletedAt: '', // AWSDateTime
        lastTestedAt: '' // AWSDateTime
    };
    for (let i = 0; i<3; i++) {

        testList.push({
            ...item,
            status: i === 2 ? Constant.MCP_SERVER_CONNECT_STATUS.SUCCESS: Constant.MCP_SERVER_CONNECT_STATUS.FAIL,
            id: `mcpServer_${uuidv4()}`,
        });
    }
    
    return testList;
}

const filterListMCPInProject = (listSetting) => {
    const listSettingInProject = listSetting.filter(item => item?.status === Constant.MCP_SERVER_CONNECT_STATUS.SUCCESS && item?.isActiveCorp);
    return listSettingInProject;
}

const getMCPServerById = async dataDto => {
    let corporationInuse =
        dataDto.affiliationOrganization || localStorageUtil.getAffiliationOrganization();
    let projectInuse = dataDto.affiliationProject || localStorageUtil.getSelectedProjectId();
    let userId = dataDto.creator || localStorageUtil.getUserDetailId();
    let getMethod = McpServerApi.MCP_SERVER_GET_METHOD.GET_MCP_SERVER_BY_ID;

    try {
        let params = {
            corporationInuse: corporationInuse,
            projectInuse: projectInuse,
            userId: userId,
            getMethod: getMethod,
            queryParams: JSON.stringify({
                limit: Constant.MCP_SERVER_GET_LIST_LIMIT,
                lastEvaluatedKey: '',
                id: dataDto.id
            })
        };

        const response = await getMCPServer(params);
        if (!response.success) {
            return {
                mcpServerDetail: {},
                error: response?.error || Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR
            };
        }

        const mcpServerDetail = Utils.convertJSONDataToObject(response.payload) || {};
        return { mcpServerDetail, error: '' };
    } catch (error) {
        console.log('getMCPServerById error: ', error);
    }
    return {};
};

const getMCPServerByIdNoValidate = async dataDto => {
    try {
        let params = {
            getMethod:  McpServerApi.MCP_SERVER_GET_METHOD.GET_MCP_SERVER_BY_ID_NO_VALIDATE,
            queryParams: JSON.stringify({
               id: dataDto.id
            }),
        };
        const response = await getMCPServer(params);
        if (!response.success) {
            return {
                mcpServerDetail: {},
                error: response?.error || Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR
            };
        }
        const mcpServerDetail = Utils.convertJSONDataToObject(response.payload) || {};
        return { mcpServerDetail, error: '' };
    } catch (error) {
        console.log('getMCPServerByIdNoValidate error: ', error);
    }
    return {};
};

/**
 * Helper function to build lastEvaluatedKey for DynamoDB pagination
 * @param {Object} lastItem - Last item from the previous fetch
 * @returns {Object} DynamoDB lastEvaluatedKey object
 */
const buildLastEvaluatedKey = (lastItem) => ({
    id: { S: lastItem.id },
    affiliationOrganization: { S: lastItem.affiliationOrganization },
    createdAt: { S: `${lastItem.createdAt}` }
});

/**
 * Fetches paginated MCP servers with filtering support
 * Continues fetching until minimum filtered items threshold is met
 * 
 * @param {Object} params - Pagination parameters
 * @param {string} params.panelType - Panel type constant
 * @param {string} params.corporationId - Corporation ID
 * @param {string} params.projectId - Project ID
 * @param {string} params.userId - User ID
 * @param {number} params.minimumItems - Minimum filtered items to fetch (default: 10)
 * @param {Function} params.filterFn - Filter function for items (default: no filter)
 * @param {Function} params.transformFn - Transform function for items (default: no transform)
 * @param {Object} params.initialLastKey - Initial pagination key (default: null)
 * @param {AbortSignal} params.signal - Abort signal for cancellation
 * @returns {Promise<Object>} { filteredItems, rawItems, hasMore, lastKey }
 */
const fetchPaginatedMCPServers = async ({
    panelType,
    corporationId,
    projectId,
    userId,
    minimumItems = Constant.MCP_SERVER_PAGINATION.MINIMUM_ITEMS,
    filterFn = null,
    transformFn = null,
    initialLastKey = null,
    signal = null
}) => {
    let rawItems = [];
    let filteredItems = [];
    let lastKey = initialLastKey;
    let hasMore = true;

    try {
        while (filteredItems.length < minimumItems && hasMore) {
            // Check for abort signal
            if (signal?.aborted) {
                throw new DOMException('Aborted', 'AbortError');
            }

            const res = await getListMCPServer(
                panelType,
                corporationId,
                projectId,
                userId,
                McpServerApi.MCP_SERVER_GET_METHOD.GET_LIST_PAGINATION,
                { lastEvaluatedKey: lastKey, signal }
            );

            const batch = res?.listMCPServer || [];
            rawItems = [...rawItems, ...batch];

            // Apply filter if provided
            const processedBatch = filterFn ? filterFn(batch) : batch;
            
            // Apply transform if provided
            const transformedBatch = transformFn 
                ? processedBatch.map(transformFn)
                : processedBatch;
            
            filteredItems = [...filteredItems, ...transformedBatch];

            // Check if backend has more data
            hasMore = batch.length >= Constant.MCP_SERVER_GET_LIST_LIMIT;

            // Update pagination key
            if (hasMore && batch.length > 0) {
                lastKey = buildLastEvaluatedKey(batch[batch.length - 1]);
            } else {
                break;
            }
        }

        return {
            filteredItems,
            rawItems,
            hasMore,
            lastKey
        };
    } catch (error) {
        if (error.name === 'AbortError') {
            throw error; // Re-throw to handle in caller
        }
        
        console.error('fetchPaginatedMCPServers error:', error);
        throw error;
    }
};

export {
    createNewInitApiData,
    getListMCPServer,
    callCheckAuthenMCPServer,
    handleUpdateMCPServerByAction,
    getOwnerByPanelType,
    transformApiDataClient,

    createTestList,
    filterListMCPInProject,
    getMCPServerById,
    getMCPServerByIdNoValidate,
    fetchPaginatedMCPServers,
    buildLastEvaluatedKey
};
